import access from "./access";
import common from "./common";
import queryform from "./queryform";

export default {
    mixins: [access, common, queryform],
};
